<template>
  <section>
    <h1 class="font-title mb-4 text-3xl/normal lg:text-4xl/normal">
      {{ course.title }}
    </h1>

    <div v-if="course.description" class="mb-6">
      <app-text-clamped
        :max-lines="3"
        trigger-color="primary"
        trigger-size="small"
        @unclamp="onUnclamp"
      >
        <app-text-markdown
          class="prose max-w-[900px]"
          data-cy-description
          lazy
          :value="course.description"
        />
      </app-text-clamped>
    </div>

    <div class="flex flex-wrap items-center gap-2 text-black">
      <course-rating-chip
        v-if="course.ratings"
        data-cy-rating-chip
        to="#ratings"
        :total-number-of-ratings="course.ratings.count"
        :value="course.ratings.avg"
      />

      <course-language-chip
        class="bg-white"
        data-cy-course-languages
        :languages="course.languages"
      />

      <course-content-type-chip class="bg-white !text-black" :course="course" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";

defineProps<{
  course: CoursePageView;
}>();

const { $analytics } = useNuxtApp();

const onUnclamp = () => {
  $analytics.track("course_description_unfolded");
};
</script>
